import { useCallback, useMemo, useState } from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, ButtonGroup } from "react-bootstrap";
import { isValidIBAN } from "ibantools";

import { Field, Form } from "../utils/components/form";
import { fetchData } from "../reducers/auftrag-reducer";
import { InputKennziffer, InputAuftragStatus, InputDate, InputGeschaeftsart } from "./components";
import { CollapseForm } from "../utils/components";
import InputFiliale from "./components/InputFiliale";

import { checkRageRight } from "../utils/functions";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";

const AuftraegeForm = (props) => {
  const { configStorage, auftragStorage, rightStorage } = useStore().getState();
  const dispatch = useDispatch();
  const apiCall = configStorage.getApiRequest("auftragsListe");  
  const [filiale, setFiliale] = useState(null);  
  // const [ablieferFiliale, setAblieferFiliale] = useState(null);  
  // const [lieferFiliale, setLieferFiliale] = useState(null);  

  const onSubmit = useCallback((data, eigeneAuftraege = false) => {    
    const { eigeneAuftraege: _, ...onlyFormData } = data || {};
    let query = { ...onlyFormData };

    if (eigeneAuftraege === true) {
      query.eigeneAuftraege = true;
    }

    if (configStorage.isDeuBa()) {
      query.iban = data.iban;
    } else {
      if (data.iban && !data.kundenkonto) {
        query.kundenkonto = String(data.iban).substring(12);      
      }
    }    
    
    if (filiale) {
      query.erfasserFiliale = filiale ? filiale : "";
    }

    if (data.auftragsNummer) {
      query = { auftragsNummer: data.auftragsNummer };
    }
    
    // if (ablieferFiliale) {
    //   query.ablieferFiliale = ablieferFiliale ? ablieferFiliale : "";
    // }

    // if (lieferFiliale) {
    //   query.lieferFiliale = lieferFiliale ? lieferFiliale : "";
    // }

    dispatch(fetchData({ apiCall, query }));
  }, [apiCall, dispatch, filiale, configStorage]);

  const validIban = (_iban, values, _props) => {
    // do not check in kundenShop as IBAN is not editable
    if (!values.iban) return undefined;
    const checkIban = String(values.iban).replace(/\s+/g, "");
    if (!isValidIBAN(checkIban)) {
      return "Bitte tragen Sie eine gültige IBAN ein.";
    } else {
      return undefined;
    }
  };

  const validDate = (date, _values, _props) => {
    const fromYear = new Date().getFullYear() - 4;
    if (new Date(date).getFullYear() < fromYear) {
      return "Das Datum muß >= 1.1." + fromYear + " sein";
    }
  };

  const showField = (field) => {    
    if (field.db_only && configStorage.isDeuBa())
      return checkRageRight(rightStorage.currentRight, [RAGE_RIGHT.RAGE_ADMIN]);
    else {
      return true;
    }
  }

  const validateDeubaBerater = useCallback((_values, _props) => {
    if (configStorage.isDeuBa() && !checkRageRight(rightStorage.currentRight, [RAGE_RIGHT.RAGE_ADMIN])) {
      const iban = document.getElementById('iban');
      const auftragsnummer = document.getElementById('auftragsNummer');
      if (iban && auftragsnummer && (iban.value || auftragsnummer.value)) {
        return undefined;
      } else {
        return "Bitte füllen Sie entweder Auftragsnummer oder IBAN aus, um zu suchen."
      }
    } else {
      return undefined;
    }
  }, [rightStorage, configStorage]);


  const queryParams = useMemo(() => ({
    ...props.queryParams,
    auftragsNummer: {
      ...props.queryParams.auftragsNummer,
      validate: validateDeubaBerater
    },
    kennziffer: {
      ...props.queryParams.kennziffer,
      type: InputKennziffer
    },
    auftragsStatus: {
      ...props.queryParams.auftragsStatus,
      type: InputAuftragStatus
    },
    geschaeftsart: {
      ...props.queryParams.geschaeftsart,
      type: InputGeschaeftsart
    },
    iban: {
      ...props.queryParams.iban,
      validate: validIban, validateDeubaBerater
    },
    datumVon: {
      ...props.queryParams.datumVon,
      type: InputDate,
      validate: validDate
    },
    datumBis: {
      ...props.queryParams.datumBis,
      type: InputDate,
      validate: validDate
    },
    personenNummer: {
      ...props.queryParams.personenNummer,
      hide: true
    },
  }), [props.queryParams, validateDeubaBerater]);

  const validate = useCallback((values) => {
    const errors = {};
    if (values.datumVon && values.datumBis && values.datumVon > values.datumBis) {
      const label = queryParams ? queryParams.datumVon.label : "";
      errors.datumBis = "muss größer oder gleich " + label + " sein";
    }
    if (values.euroVon && values.euroBis && Number(values.euroVon) > Number(values.euroBis)) {
      const label = queryParams ? queryParams.euroVon.label : "";
      errors.euroBis = "muss größer oder gleich " + label + " sein";
    }
    return errors;
  }, [queryParams]);

  return <div>
    <CollapseForm>
      <Form onSubmit={onSubmit} validateOnBlur {...props} validate={validate}>
        {({ handleSubmit, form }) => {
          const { errors, invalid, pristine } = form.getState();
          const onClick = (e) => {
            const formState = form.getState();
            if (formState.hasValidationErrors) return false;
            if (formState.submitSucceeded && !formState.modifiedSinceLastSubmit && formState.datumBis) return false;
            return handleSubmit(e);
          };

          return <>
            <form onSubmit={onSubmit} className="row row-cols-2">
              {Object.keys(queryParams).map((key, idx) => {
                const field = queryParams[key];
                return <Field name={key} key={key} validate={field.validate}>
                  {({ input, meta }) => {
                    if ((field.type === undefined || typeof field.type === "string") && ( !field.hide ) && ( !field.erfasser_select ) && ( !field.abliefer_select ) && ( !field.liefer_select ) && (!configStorage.isDeuBa() || !field.db_not) && !(!configStorage.isDeuBa() && field.db_only) && showField(field)) {
                      return <div key={key} className={"row grid-" + (idx % 2)}>
                        <label className="col-6 col-form-label col-form-label-sm" htmlFor={key}>{field.label}</label>
                        <div className="col-6">
                          <input
                            className="form-control form-control-sm"
                            aria-label={field.ariaLabel}
                            type={field.type}
                            id={key}
                            {...input} />
                        </div>
                      </div>;
                    } else if (typeof field.type === "function") {
                      const Input = field.type;
                      return <Input className={"grid-" + (idx % 2)} field={field} {...input} meta={meta} />;
                  
                    } else if (configStorage.isDeuBa() && field.erfasser_select && checkRageRight(rightStorage.currentRight, [RAGE_RIGHT.RAGE_ADMIN])) {
                      return <div key={key} className={"row grid-" + (idx % 2)}>
                        <label className="col-6 col-form-label col-form-label-sm" htmlFor="erfasserFiliale">
                          Erfasserfiliale
                        </label>
                        <div className="col-6">
                            <InputFiliale id="erfasserFiliale" value={filiale} onChange={setFiliale} />
                        </div>
                      </div>;
                    // } else if (field.liefer_select) {
                    //   return <div key={key} className={"row grid-" + (idx % 2)}>
                    //     <label className="col-6 col-form-label col-form-label-sm" htmlFor="lieferFiliale">
                    //       Liefer- / Ablieferfiliale
                    //     </label>                        
                    //     <div className="col-6">
                    //       <InputFiliale id="lieferFiliale" value={lieferFiliale} onChange={setLieferFiliale} />
                    //     </div>
                    //   </div>;
                    // }  else if (field.abliefer_select) {
                    //   // return <div key={key} className={"row grid-" + (idx % 2)}>
                    //   //   <label className="col-6 col-form-label col-form-label-sm" htmlFor="ablieferFiliale">
                    //   //     Ablieferfiliale
                    //   //   </label>
                    //   //   <div className="col-6">                         
                    //   //     <InputFiliale id="ablieferFiliale" value={ablieferFiliale} onChange={setAblieferFiliale} />                            
                    //   //   </div>
                    //   // </div>;
                    //   return <div key={key} className={"row grid-" + (idx % 2)}>
                    //     <div className="col-6"></div>
                    //     <div className="col-6"></div>
                    //   </div>;
                    }else if (!showField(field)) {
                      return <div key={key} className={"row grid-" + (idx % 2)}>
                        <div className="col-6"></div>
                        <div className="col-6"></div>
                      </div>;
                    } 
                  }}
                </Field>;
              })}              
              <ButtonGroup className="mt-one">
                <Button type="button" disabled={invalid} onClick={onClick}>
                  Hole Liste der Aufträge
                </Button>                
                <Button variant="default" onClick={form.reset} disabled={pristine}>Formular zurücksetzen</Button>                
              </ButtonGroup>
              {/* <ButtonGroup className="mt-one col-2">
                <Button
                  type="button"
                  disabled={invalid}
                  onClick={(e) => {
                    const formState = form.getState();
                    if (formState.hasValidationErrors) return false;
                    if (formState.submitSucceeded && !formState.modifiedSinceLastSubmit && formState.datumBis) return false;
                    return onSubmit(formState.values, true);
                  }}
                >
                  Nur eigene Aufträge
                </Button>                                
              </ButtonGroup> */}
            </form>
            {errors && Object.keys(errors).length
              ? <div className="alert alert-danger fs-6 p-1">
                {Object.keys(errors).map(e => <div key="{e}">{queryParams[e].label}: {errors[e]}</div>)}</div>
              : null
            }
          </>;
        }}
      </Form>
    </CollapseForm>
    {auftragStorage.errorStatus
      ? <div className="alert alert-danger">{auftragStorage.errorStatus.message}</div>
      : null
    }
  </div>;
};
export default AuftraegeForm;

// {/* { configStorage.isDeuBa() ? 
//   (
//     <div className={"row grid-" + (Object.keys(queryParams).length % 2)}>
//       <label className="col-6 col-form-label col-form-label-sm" htmlFor="erfasserFiliale">
//         Erfasser Filiale
//       </label>
//       <div className="col-6">
//         <InputFiliale id="erfasserFiliale" value={filiale} onChange={setFiliale} />
//       </div>
//     </div>
//   ) : null 
// } */}
